// Model-specific AI previews; supplier print masks pending.
window.PhoneCaseModels = Object.freeze([
  {
    "brand": "Apple",
    "name": "iPhone 14",
    "width": 71.5,
    "height": 146.7,
    "camera": "diagonal",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-14-v6.png?v=1791672404",
      "crop": [
        43,
        54,
        795,
        1670
      ],
      "camera": [
        0.045,
        0.025,
        0.47000000000000003,
        0.23500000000000001
      ],
      "radius": 0.055
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 14 Plus",
    "width": 78.1,
    "height": 160.8,
    "camera": "diagonal",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-14-plus-v6.png?v=1791672418",
      "crop": [
        131,
        76,
        742,
        1424
      ],
      "camera": [
        0.04316711590296496,
        0.025,
        0.47183288409703505,
        0.23500000000000001
      ],
      "radius": 0.055
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 14 Pro",
    "width": 71.5,
    "height": 147.5,
    "camera": "pro",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-14-pro-v6.png?v=1791672392",
      "crop": [
        242,
        66,
        650,
        1273
      ],
      "camera": [
        0.045,
        0.025,
        0.53,
        0.29
      ],
      "radius": 0.06
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 14 Pro Max",
    "width": 77.6,
    "height": 160.7,
    "camera": "pro",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-14-pro-max-v6.png?v=1791672431",
      "crop": [
        252,
        57,
        629,
        1290
      ],
      "camera": [
        0.045,
        0.025,
        0.53,
        0.29
      ],
      "radius": 0.06
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 15",
    "width": 71.6,
    "height": 147.6,
    "camera": "diagonal",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-15-v6.png?v=1791672443",
      "crop": [
        55,
        94,
        771,
        1613
      ],
      "camera": [
        0.045,
        0.025,
        0.47000000000000003,
        0.23500000000000001
      ],
      "radius": 0.055
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 15 Plus",
    "width": 77.8,
    "height": 160.9,
    "camera": "diagonal",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-15-plus-v6.png?v=1791672455",
      "crop": [
        145,
        76,
        716,
        1431
      ],
      "camera": [
        0.04460893854748603,
        0.025,
        0.47039106145251397,
        0.23500000000000001
      ],
      "radius": 0.055
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 15 Pro",
    "width": 70.6,
    "height": 146.6,
    "camera": "pro",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-15-pro-v6.png?v=1791672538",
      "crop": [
        181,
        52,
        692,
        1397
      ],
      "camera": [
        0.045,
        0.025,
        0.53,
        0.29
      ],
      "radius": 0.06
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 15 Pro Max",
    "width": 76.7,
    "height": 159.9,
    "camera": "pro",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-15-pro-max-v6.png?v=1791672550",
      "crop": [
        45,
        82,
        788,
        1645
      ],
      "camera": [
        0.045,
        0.025,
        0.53,
        0.29
      ],
      "radius": 0.06
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 16",
    "width": 71.6,
    "height": 147.6,
    "camera": "vertical",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-16-v6.png?v=1791672563",
      "crop": [
        181,
        56,
        689,
        1395
      ],
      "camera": [
        0.03611756168359942,
        0.025,
        0.35888243831640054,
        0.2558960573476702
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 16 Plus",
    "width": 77.8,
    "height": 160.9,
    "camera": "vertical",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-16-plus-v6.png?v=1791672577",
      "crop": [
        63,
        92,
        750,
        1623
      ],
      "camera": [
        0.03966666666666667,
        0.025,
        0.3553333333333333,
        0.24591189155884166
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 16 Pro",
    "width": 71.5,
    "height": 149.6,
    "camera": "pro",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-16-pro-v6.png?v=1791672589",
      "crop": [
        55,
        89,
        761,
        1639
      ],
      "camera": [
        0.045,
        0.025,
        0.5603022339027596,
        0.29
      ],
      "radius": 0.06
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 16 Pro Max",
    "width": 77.6,
    "height": 163,
    "camera": "pro",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-16-pro-max-v6.png?v=1791672737",
      "crop": [
        61,
        70,
        751,
        1675
      ],
      "camera": [
        0.045,
        0.025,
        0.5359387483355526,
        0.29
      ],
      "radius": 0.06
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 17",
    "width": 71.5,
    "height": 149.6,
    "camera": "vertical",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-17-v6.png?v=1791672801",
      "crop": [
        46,
        108,
        781,
        1604
      ],
      "camera": [
        0.045,
        0.025,
        0.35,
        0.26684538653366585
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 17 Pro",
    "width": 71.9,
    "height": 150,
    "camera": "plateau",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-17-pro-corrected-v6.png?v=1791741155",
      "crop": [
        167,
        53,
        710,
        1416
      ],
      "camera": [
        0.035,
        0.02,
        0.93,
        0.27483050847457624
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 17 Pro Max",
    "width": 78,
    "height": 163.4,
    "camera": "plateau",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-17-pro-max-v6.png?v=1791672749",
      "crop": [
        134,
        70,
        731,
        1453
      ],
      "camera": [
        0.035,
        0.02,
        0.93,
        0.26602202339986236
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone Air",
    "width": 74.7,
    "height": 156.2,
    "camera": "air",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-air-v6.png?v=1791672761",
      "crop": [
        252,
        70,
        627,
        1263
      ],
      "camera": [
        0.035,
        0.02,
        0.93,
        0.165
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 18 Pro",
    "width": 71.9,
    "height": 150,
    "camera": "plateau",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-18-pro-corrected-v6.png?v=1791741171",
      "crop": [
        160,
        56,
        711,
        1433
      ],
      "camera": [
        0.035,
        0.02,
        0.93,
        0.2702930914166085
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Apple",
    "name": "iPhone 18 Pro Max",
    "width": 78,
    "height": 163.4,
    "camera": "plateau",
    "corner": 9,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-iphone-18-pro-max-corrected-v6.png?v=1791741189",
      "crop": [
        99,
        57,
        787,
        1493
      ],
      "camera": [
        0.035,
        0.02,
        0.93,
        0.2705492297387809
      ],
      "radius": 0.065
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S24",
    "width": 70.6,
    "height": 147,
    "camera": "samsung",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s24-v6.png?v=1791672467",
      "crop": [
        39,
        52,
        785,
        1704
      ],
      "camera": [
        0.045,
        0.025,
        0.37,
        0.335
      ],
      "radius": 0.04
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S24+",
    "width": 75.9,
    "height": 158.5,
    "camera": "samsung",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s24plus-v6.png?v=1791672482",
      "crop": [
        40,
        77,
        778,
        1653
      ],
      "camera": [
        0.045,
        0.025,
        0.37,
        0.335
      ],
      "radius": 0.04
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S24 Ultra",
    "width": 79,
    "height": 162.3,
    "camera": "samsung-ultra",
    "corner": 3,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s24-ultra-v6.png?v=1791672495",
      "crop": [
        62,
        90,
        752,
        1611
      ],
      "camera": [
        0.04,
        0.025,
        0.456436170212766,
        0.345
      ],
      "radius": 0.035
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S25",
    "width": 70.5,
    "height": 146.9,
    "camera": "samsung",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s25-v6.png?v=1791672602",
      "crop": [
        50,
        87,
        763,
        1636
      ],
      "camera": [
        0.042326343381389256,
        0.025,
        0.37267365661861074,
        0.339963325183374
      ],
      "radius": 0.04
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S25+",
    "width": 75.8,
    "height": 158.4,
    "camera": "samsung",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s25plus-v6.png?v=1791672615",
      "crop": [
        35,
        85,
        782,
        1657
      ],
      "camera": [
        0.03916879795396419,
        0.025,
        0.3758312020460358,
        0.33632166566083277
      ],
      "radius": 0.04
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S25 Ultra",
    "width": 77.6,
    "height": 162.8,
    "camera": "samsung-ultra",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s25-ultra-v6.png?v=1791672628",
      "crop": [
        54,
        70,
        750,
        1672
      ],
      "camera": [
        0.04,
        0.025,
        0.4616666666666667,
        0.35009569377990424
      ],
      "radius": 0.035
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S26",
    "width": 71.7,
    "height": 149.6,
    "camera": "samsung-pill",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s26-v6.png?v=1791672642",
      "crop": [
        33,
        52,
        795,
        1706
      ],
      "camera": [
        0.045,
        0.025,
        0.38,
        0.340873388042204
      ],
      "radius": 0.07
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S26+",
    "width": 75.8,
    "height": 158.4,
    "camera": "samsung-pill",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s26plus-corrected-v6.png?v=1791741206",
      "crop": [
        43,
        54,
        775,
        1702
      ],
      "camera": [
        0.03854838709677419,
        0.025,
        0.3864516129032258,
        0.335
      ],
      "radius": 0.07
    }
  },
  {
    "brand": "Samsung",
    "name": "Galaxy S26 Ultra",
    "width": 78.1,
    "height": 163.6,
    "camera": "samsung-ultra-pill",
    "corner": 7,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-galaxy-s26-ultra-v6.png?v=1791672696",
      "crop": [
        43,
        77,
        777,
        1657
      ],
      "camera": [
        0.04,
        0.025,
        0.4699034749034749,
        0.3562371756185878
      ],
      "radius": 0.07
    }
  },
  {
    "brand": "Xiaomi",
    "name": "Redmi 14C (4G)",
    "width": 77.8,
    "height": 171.88,
    "camera": "redmi-circle",
    "corner": 8,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-redmi-14c-4g--v6.png?v=1791672707",
      "crop": [
        354,
        68,
        542,
        1124
      ],
      "camera": [
        0.12,
        0.045,
        0.7655535055350554,
        0.39
      ],
      "radius": 0.3
    }
  },
  {
    "brand": "Motorola",
    "name": "Moto G15",
    "width": 75.98,
    "height": 165.67,
    "camera": "moto",
    "corner": 8,
    "preview": {
      "url": "https://cdn.shopify.com/s/files/1/0999/8385/1853/files/momente-case-moto-g15-v6.png?v=1791672722",
      "crop": [
        46,
        72,
        753,
        1709
      ],
      "camera": [
        0.04,
        0.025,
        0.5235524568393094,
        0.2507577530719719
      ],
      "radius": 0.06
    }
  }
]);
